import styled from 'styled-components';

export const StyledSpinnerContiner = styled.div`
    position: relative;
    height: 30px;
    width: 172px;
`;
